import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    button: {
      width: '100%',
      padding: theme.spacing(2, 3),
      textAlign: 'left',
      textTransform: 'initial',
      borderRadius: 25,
      boxShadow: '0px 5px 20px #64646433',
      display: 'inline-flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& h2': {
        marginBottom: theme.spacing(1),
        fontSize: theme.typography.pxToRem(20),
        fontWeight: theme.typography.fontWeightBold,
      },
      '& p': {
        maxWidth: '89%',
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.primary.contrastText,
      },
    },
    building: {
      background: 'linear-gradient(250deg, #C4EE7E 0%, #98C44E 100%)',
      '& h2': {
        color: '#355400',
      },
    },
    health: {
      background: 'linear-gradient(250deg, #B5E8FF 0%, #208DBE 100%)',
      '& h2': {
        color: theme.palette.common.white,
      },
    },
    vaccine: {
      background: 'linear-gradient(250deg, #B5E8FF 0%, #208DBE 100%)',
      '& h2': {
        color: '#295190',
      },
    },
    quiz: {
      background: 'linear-gradient(250deg, #B5E8FF 0%, #208DBE 100%)',
      '& h2': {
        color: theme.palette.common.white,
      },
    },
  })
);

export default useStyles;
